import type { EventExtra } from '@cocoonspace/sdk-js/types/eventExtra'
import Image from 'next/image'

export const ExtraImages = ({
	extra,
	className,
}: {
	extra: EventExtra
	className?: string
}) => (
	<Image
		alt={extra.title || ''}
		className={className}
		height='60'
		src={`${process.env.NEXT_PUBLIC_TWICPICS_DOMAIN}/${process.env.NEXT_PUBLIC_TWICPICS_PATH}/content/extras/${extra.image_url}`}
		width='80'
	/>
	// <TwicImg
	// 	src={`/content/extras/${extra.image_url}`}
	// 	alt={extra.id.toLowerCase()}
	// 	className='h-[60px] w-[80px]'
	// />
)
